export const offsetTop = (result: number, container?: HTMLElement): number => {
    if (!container || container.offsetTop === undefined) return result;
    else {
        result += container.offsetTop;
        if (container.offsetParent) {
            return offsetTop(result, container.offsetParent as HTMLElement);
        } else {
            return result;
        }
    }
};

export const offsetLeft = (result: number, container?: HTMLElement): number => {
    if (!container || container.offsetLeft === undefined) return result;
    else {
        result += container.offsetLeft;
        if (container.offsetParent) {
            return offsetLeft(result, container.offsetParent as HTMLElement);
        } else {
            return result;
        }
    }
};
